import React from 'react';
import { ReactEditor } from 'slate-react';
import styles from '../../../../components/Toolbar/Toolbar.module.css';
import classnames from 'classnames';
import { type ToolbarSubmenuProps } from '../../../../types/aha-editor';
import type ToolMark from '../../tools/ToolMark';
import MarkUtils from '../../../../AhaEditorUtils/MarkUtils';

interface FontSize {
  displayName: string;
  styleName: string;
}

const DEFAULT_FONT_SIZE_LIST: FontSize[] = [
  { displayName: '10', styleName: '10px' },
  { displayName: '12', styleName: '12px' },
  { displayName: '13', styleName: '13px' },
  { displayName: '14', styleName: '14px' },
  { displayName: '16', styleName: '16px' },
  { displayName: '18', styleName: '18px' },
  { displayName: '20', styleName: '20px' },
  { displayName: '22', styleName: '22px' },
  { displayName: '24', styleName: '24px' },
  { displayName: '30', styleName: '30px' },
  { displayName: '36', styleName: '36px' },
  { displayName: '48', styleName: '48px' },
];

const DEFAULT_FONT_SIZE = '13px';

const FontSizePicker: React.FC<ToolbarSubmenuProps<typeof ToolMark>> = ({
  editor,
  controller,
  tool,
  isSubmenu,
}) => {
  const currentFontSize =
    MarkUtils.getMarkAtSelection(editor, tool.mark) ?? DEFAULT_FONT_SIZE;

  const handleFontSizeChange = (fontSize: FontSize) => {
    tool.addMark(editor, controller, fontSize.styleName);
    ReactEditor.focus(editor);
  };

  return (
    <aha-menu submenu={isSubmenu}>
      <div
        slot="control"
        className={classnames({
          [styles.toolbarButtonDisabled]: !tool.isEnabled({
            editor,
            controller,
          }),
        })}
      >
        <i className={classnames('fa-fw', tool.iconClass)} />
        {isSubmenu && tool.label}
      </div>
      <aha-menu-content>
        {DEFAULT_FONT_SIZE_LIST.map((fontSize) => (
          <aha-menu-item
            key={`font-size-${fontSize.displayName}`}
            selected={fontSize.styleName === currentFontSize ? true : null}
            onClick={(event) => handleFontSizeChange(fontSize)}
          >
            <div style={{ padding: '6px 8px' }}>{fontSize.displayName}</div>
          </aha-menu-item>
        ))}
      </aha-menu-content>
    </aha-menu>
  );
};

export default FontSizePicker;
